import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchLoginFormAsync } from '../thunks/LoginThunk';
import { STATUS } from './userDetailslice';
export interface Login {
    token: string | null;
    userName:string |null;
    userType:string | null;
    cameraStream: any | null;
    loginFormDetails:AppDetails | null;
    status: string;   
}
export interface AppDetails {
    appId: string;
    name: string;
    authMethods: string[];
    title: string;
    logoImageUrl:string;
  }


const initialLoginSliceState: Login = {
    token: null,
    userName: null,
    userType: null,
    cameraStream: null,
    loginFormDetails: null,
    status: STATUS.IDLE,

}

const loginSlice = createSlice({
    name: 'loginDetails',
    initialState: initialLoginSliceState,
    reducers: {
      
        saveCameraStream: (state, action: PayloadAction<any>)=>{
            state.cameraStream = action.payload
        }

    },
    extraReducers: (builder) => {
        builder
          .addCase(fetchLoginFormAsync.pending, (state) => {
            state.status = STATUS.LOADING;
          })
          .addCase(fetchLoginFormAsync.fulfilled, (state, action) => {
            state.loginFormDetails = action.payload;
            state.status = STATUS.SUCCESS;
          })
          .addCase(fetchLoginFormAsync.rejected, (state, action) => {
            state.status = STATUS.FAILED;
          })
        }
});

export const { saveCameraStream} = loginSlice.actions;



export default loginSlice.reducer;